import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { rebaseUrl } from '@fc-shared/utils/request-utils/rebase-url';

/**
 * Rewrites requests to known backend hosts onto their local proxy prefix
 * (`environment.proxiedHosts`). The backend returns absolute URLs (DRF
 * hyperlinks, pagination `next` links, CMS `detail_url`); when the app runs
 * behind the dev-server proxy those must not be requested directly, or they
 * bypass the proxy. Inert outside proxy configurations, where `proxiedHosts`
 * is undefined.
 */
export const proxiedHostsInterceptor: HttpInterceptorFn = (request, next) => {
  const proxiedUrl = resolveProxiedUrl(request.url, environment.proxiedHosts);

  return next(
    proxiedUrl === request.url ? request : request.clone({ url: proxiedUrl }),
  );
};

export function resolveProxiedUrl(
  url: string,
  proxiedHosts: Record<string, string> | undefined,
): string {
  if (!proxiedHosts || !/^https?:\/\//i.test(url)) {
    return url;
  }

  const proxyPrefix = proxiedHosts[new URL(url).host];

  return proxyPrefix ? rebaseUrl(proxyPrefix, url) : url;
}
